import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";

export const addDocument = async (collectionName, documentData) => {
  try {
    const docRef = await addDoc(collection(db, collectionName), documentData);
    console.log("Document written with ID: ", docRef.id);
  } catch (e) {
    console.error("Error adding document: ", e);
  }
};
